<section class="o-section">
    <div class="o-wrapper">
      <div class="o-layout">
        <div class="o-layout__item [ u-10/12@desktop u-push-1/12@desktop ]">
          <div class="u-margin-bottom-large [ u-11/12@tablet u-7/12@desktop ]">
            <h1 class="c-heading-page">{{ 'HOME/VIDEO-CAROUSEL.Welcome' | translate }}</h1>
            <div class="text-heading"> {{ 'REGISTRATION-FORM.experience_launcher_description' | translate }}</div>
            <div class="c-form-field c-form-field--buttons">
                <form [formGroup]="optionsForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <div class="option-card" data-cy="experience-launcher-pap" [class.selected]="optionsForm.get('therapyPAP')?.value" (click)="setValue('therapyPAP')">
                            <div class="option-content">
                              <img src="assets/images/experience_launcher_therapy_pap@2x.png" alt="" class="option-image" />
                              <div class="option-text">
                                {{ 'REGISTRATION-FORM.experience_launcher_therapy_card_header' | translate }}
                              </div>
                            </div>
                            <svg class="c-svg c-svg--checkmark" *ngIf="optionsForm.get('therapyPAP')?.value">
                                <use xlink:href="#c-svg--checkmark"></use>
                            </svg>
                            <div class="checkmark-abscence" *ngIf="!optionsForm.get('therapyPAP')?.value"></div>
                        </div>

                        @if (isPreTherapyCountry) {
                        <div class="option-card" data-cy="experience-launcher-pretherapy" [class.selected]="optionsForm.get('preTherapy')?.value" (click)="setValue('preTherapy')">
                            <div class="option-content">
                              <img src="assets/images/experience_launcher_pretherapy@2x.png" alt="" class="option-image" />
                              <div class="option-text">
                                {{ 'REGISTRATION-FORM.experience_launcher_pre_therapy_card_header' | translate }}
                              </div>
                            </div>
                            <svg class="c-svg c-svg--checkmark" *ngIf="optionsForm.get('preTherapy')?.value">
                                <use xlink:href="#c-svg--checkmark"></use>
                            </svg>
                            <div class="checkmark-abscence" *ngIf="!optionsForm.get('preTherapy')?.value"></div>
                        </div>
                        }

                        @if (isTherapyRCCountry) {
                          <div class="option-card" data-cy="experience-launcher-rc" [class.selected]="optionsForm.get('therapyRC')?.value" (click)="setValue('therapyRC')">
                              <div class="option-content">
                                <img src="assets/images/experience_launcher_therapy_rc_mariana@2x.png" alt="" class="option-image" />
                                <div class="option-text">
                                  {{ 'REGISTRATION-FORM.experience_launcher_therapy_rc_card_header' | translate }}
                                </div>
                              </div>
                              <svg class="c-svg c-svg--checkmark" *ngIf="optionsForm.get('therapyRC')?.value">
                                  <use xlink:href="#c-svg--checkmark"></use>
                              </svg>
                              <div class="checkmark-abscence" *ngIf="!optionsForm.get('therapyRC')?.value"></div>
                          </div>
                        }
                    </div>
                    <div class="buttons">
                        <div class="c-form-field--buttons-wizard__next">
                            <button class="c-btn c-btn--primary" type="submit" [disabled]="isSubmitDisabled()">
                            {{"PTA.PtaStepperNext" | translate}}
                            </button>
                        </div>
                        <div class="c-form-field--buttons-wizard__back">
                            <button type="button" class="c-btn c-btn--tertiary" (click)="onCancel()">
                            {{"REGISTRATION-FORM.Cancel" | translate}}
                            </button>
                        </div>
                    </div>
                </form>
                </div>
          </div>
        </div>
      </div>
    </div>
</section>